module.exports = __webpack_public_path__ + "static/media/praying-hands.d86c3bb9.svg";